<template>
    <div id="vehicle_reg_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Warranty Registration List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary mr-2" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAddVehicleRegistration" class="btn btn-primary pull-right" v-bind:to="{name: 'VehicleRegistrationCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vehicle-registration-list">
                        <data-table-filter-config :moduleName="'vehicleRegistrationList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'vehicleRegistrationList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listVehicleRegTable"
                                    mode="remote"
                                    title="VehicleRegistration"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: delete_btn_access,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="View Warranty Registration" v-if="canUpdateVehicleRegistration" class="fp-view" v-bind:to="{name: 'VehicleRegistrationView',params:{id:props.row.id}}"></router-link>
                                                <a
                                                  v-if="props.row.file_path != null"
                                                  @click.prevent="downloadPdf(props.row)"
                                                  style="cursor: pointer"
                                                >
                                                  <i class="fp-print"></i>
                                                </a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="delete_btn_access" id="deleteVehicleTypeBtn" v-on:click.prevent="VehicleTypesDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "././event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleTypesList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        mixins:[commonMixins,dataTableMixins],
        metaInfo() {
            return {title: "Warranty Registration List | " +process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'VIN',
                    field: 'vin',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Year',
                    field: 'year',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Make',
                    field: 'make',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Make", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Model',
                    field: 'model',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
              {
                label: 'Dealer Code',
                field: 'dealer_code',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Dealer Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
              {
                label: 'Dealer Name',
                field: 'dealer_name_location',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Dealer Name", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
              {
                label: 'Registration Date',
                field: 'registration_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
              {
                label: 'Basic Coverage Expiration',
                field: 'basic_coverage_expiration',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
              {
                label: 'Created By',
                field: 'user_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Created by user name", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
              {
                label: 'Created At',
                field: 'created_at',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                }
              },
            ],
            rows: [],
            totalRecords: 0,
            delete_btn_access: false,
            loading:false,
            canUpdateVehicleRegistration:false,
            canAddVehicleRegistration:false,
            pageKey:"_vehicle_registration_list_",
            action:"list",
            batchProcess:0,
            batchNum:""
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_vehicle_registration') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_vehicle_registration') {
                            self.delete_btn_access = true;
                        }
                        if (permissions[i].name == 'add_vehicle_registration') {
                            self.canAddVehicleRegistration = true;
                            self.canUpdateVehicleRegistration = true;
                        }
                      if (permissions[i].name == 'ev_list_vehicle_registration') {
                        self.cantAccessPage = true;
                      }
                      if (permissions[i].name == 'ev_delete_vehicle_registration') {
                        self.delete_btn_access = true;
                      }
                      if (permissions[i].name == 'ev_add_vehicle_registration') {
                        self.canAddVehicleRegistration = true;
                        self.canUpdateVehicleRegistration = true;
                      }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleRegTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                var self = this;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;

                if( self.totalRecords < (params.currentPerPage * this.serverParams.page) ) {
                    this.updateParams({page: 1});
                } else {

                    this.updateParams({page: params.currentPage});
                }
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('is_default');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.is_default) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;

                var selectedRows = [];
                if ( self.firstLoad == 1 ) {
                    //because on first load list not initialize
                    var data = this.$refs['listVehicleRegTable'].selectedRows;
                    for ( var i = 0; i < data.length; i++ ) {
                        selectedRows.push(this.$refs['listVehicleRegTable'].selectedRows[i].id)
                    }
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    selectedRows:selectedRows,
                    action:self.action
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vehicleregistration/list",
                    type: "POST",
                    data: fields,
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        "Access-Control-Allow-Headers":
                            "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if(self.action == 'export' || self.action == 'export_queue'){
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);
                                    } else {
                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                      console.log(jqXHR);
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'vehicle-registration-list')
                    }
                });
            },
            VehicleTypesDelete() {

                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Vehicle Registration?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listVehicleRegTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listVehicleRegTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteVehicleTypeBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/vehicleregistration/delete",
                          type: "POST",
                          data: 'ids=' + use,
                          headers: {
                              'Accept': 'application/json',
                              "Access-Control-Allow-Origin": '*',
                              "Authorization": "Bearer " + localStorage.getItem("tkn"),
                              'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                              "Cache-Control": "no-cache"
                          },
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteVehicleTypeBtn").val("Delete");
                              }, 10000);
                              if (data.status == 'used'){
                                  self.$swal('',data.message,'info');
                                  return;
                              }
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,false,'vehicle-registration-delete')
                          }
                      });

                    } else {
                      console.log("no");
                    }
                });
            },
            goToGetDocumentPath(event, row){
                event.preventDefault();
                var self = this;
                var path = row.file_path;
                var flag = '';
                var id = 0;

                self.getDocumentPath(id, path, flag);
            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listVehicleRegTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            downloadPdf(row) {
              var self = this;
              self.loading = true ;
              $.ajax({
                url: process.env.ROOT_API + "/vehicle-registration/download/"+row.id,
                type: "POST",
                data: {
                  vehicle_registration_id:row.id,
                },
                headers: {
                  'Accept': 'application/json',
                  "Access-Control-Allow-Origin": '*',
                  "Authorization": "Bearer " + localStorage.getItem("tkn"),
                  'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                  "Cache-Control": "no-cache"
                },
                dataType: 'json',
                success: function (data) {
                  self.loading = false ;
                  if (data.status === 'success'){
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data.content;
                    link.download = '';
                    link.target = "_blank";
                    link.click();
                  }
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'vehicle-registration-form-download');
                }
              });

            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/VehicleRegistrationList.vue